import * as SelectPrimitive from "@radix-ui/react-select";
import { Check } from "lucide-react";

import { SadieSimulatorFitTag } from "./SadieSimulatorFitTag";

import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import {
  SadieSimulatorMatchedOpportunityFit,
  SadieSimulatorMatchedOpportunityOption,
} from "@/types";

// A two-line select option: the job on the first line, the fit note on the
// second. Built on the Radix primitive rather than the shadcn SelectItem
// because only what sits inside ItemText echoes into the closed trigger, and
// the note should stay in the list.
export const SadieSimulatorOpportunityItem = ({
  fit,
  isFitPending,
  option,
}: {
  // Undefined while a judge read is still being written, or if it failed.
  fit?: SadieSimulatorMatchedOpportunityFit;
  isFitPending: boolean;
  option: SadieSimulatorMatchedOpportunityOption;
}) => {
  return (
    <SelectPrimitive.Item
      className="relative flex w-full cursor-default select-none items-start rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
      value={option.key}
    >
      <span className="absolute left-2 top-2 flex h-3.5 w-3.5 items-center justify-center">
        <SelectPrimitive.ItemIndicator>
          <Check className="h-4 w-4" />
        </SelectPrimitive.ItemIndicator>
      </span>
      <Column className="items-start gap-1">
        <SelectPrimitive.ItemText>
          {option.matchedOpportunity.pay
            ? `${option.label}, ${option.matchedOpportunity.pay}`
            : option.label}
        </SelectPrimitive.ItemText>
        {fit ? <SadieSimulatorFitTag fit={fit.fit} /> : null}
        {!fit && isFitPending ? (
          <span className="whitespace-nowrap rounded-md bg-slate-100 px-1.5 py-0.5 text-[11px] font-medium text-slate-400">
            reading fit
          </span>
        ) : null}
        {fit ? (
          <Text className="text-xs font-normal leading-snug text-slate-500">
            {fit.note}
          </Text>
        ) : null}
      </Column>
    </SelectPrimitive.Item>
  );
};
